var _excluded = ["iconName", "color", "className", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { colorNames } from '../../constants';
/**
 * Status: *In progress*.
 * Category: Style
 *
 * A component that is used to create external reference to svg icons from the icon assets.
 * To show an icon, give the name of the icon (without file ending) and the desired color (defaults to black).
 */

var SvgIcon = function SvgIcon(_ref) {
  var _classnames;

  var iconName = _ref.iconName,
      color = _ref.color,
      className = _ref.className,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: classnames('svg-icon', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "svg-icon--".concat(color || 'black'), color), _classnames)),
    "aria-hidden": title ? undefined : true
  }, rest), title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(iconName)
  }));
};

SvgIcon.propTypes = {
  /** The name of the icon*/
  iconName: PropTypes.string,

  /** The color of the icon (white, black, ... Se Color Palette)*/
  color: PropTypes.oneOf(colorNames),

  /** Other class names*/
  className: PropTypes.string,
  title: PropTypes.string
};
export default SvgIcon;